function addSelectedToSubscription(sectionId, isSubscription = false, productData = null) {
  const productInfo = productData ? JSON.parse(productData) : {};
  const root = document?.getElementById('mpg-root--' + sectionId);
  if (!root) return;

  const select = root.querySelector('#productSelect--' + sectionId);
  const sellingPlanIdInput = root.querySelector('#selectedSellingPlan--' + sectionId);
  const pgmBtnAddToCart = root.querySelector('#pgmBtnAddToCart--' + sectionId);
  const mainProductImage = root.querySelector('#mpgImage');
  if (!mainProductImage || !pgmBtnAddToCart) return;

  const selectedPlanId = select?.value;
  if(isSubscription && selectedPlanId != ""){
    const resolvedImage = productInfo.subscription_image && !(productInfo.subscription_image.includes("error")) ? productInfo.subscription_image : productInfo.image;
    if (resolvedImage) mainProductImage.src = resolvedImage;
    pgmBtnAddToCart.innerHTML = "<span>Subscribe & Save</span>";
    if (sellingPlanIdInput) sellingPlanIdInput.value = selectedPlanId;
  }else{
    if (productInfo.image) mainProductImage.src = productInfo.image;
    pgmBtnAddToCart.innerHTML = "<span>Add to Cart</span>";
    if (sellingPlanIdInput) sellingPlanIdInput.value = "";
    if (select) select.value = "";
  }
}
function handleQuantity(type){
  const quantityInput = document?.querySelector('#quantityInputPmg');
  if(type == "plus") return Number(quantityInput.value) + 1;
  if(quantityInput.value > 1) return Number(quantityInput.value) - 1;
}